import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { WizardPageType } from '@rover/react-lib/src/pages/search/SearchPage/WizardPageType';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';
import { selectors as serviceTypeSelectors } from '@rover/react-lib/src/redux/ducks/serviceTypes.duck';
import type { SearchFiltersOptions } from '@rover/types/src/apiResponses/SearchOptionsResponse';
import type { SearchFilters } from '@rover/types/src/SearchFilters';
import type { ServiceTypeOption } from '@rover/types/src/ServiceType';

import PageOneWizardCollection from './PageOneWizardCollection';

export type Props = {
  isCatOnly: boolean;
  onChange: (arg0: Partial<SearchFilters>, arg1?: boolean) => void;
  pageType: WizardPageType;
  searchFilters: SearchFilters;
  serviceTypeFilterOptions: SearchFiltersOptions;
  serviceTypeOptions: ServiceTypeOption[];
  locationInputId?: string;
};

const selector = (state) => ({
  getServiceTypeBySlug: serviceTypeSelectors.getServiceTypeBySlug(state),
  hasPets: searchSelectors.getHasPets(state),
  language: frontendConfigurationSelectors.getLanguage(state),
  priceTransparencyLevel: searchSelectors.getPriceTransparencyLevel(state),
});

const PageOneWizardCollectionContainer = (props: Props): JSX.Element => (
  <Connect selector={selector}>
    {(connectedProps) => <PageOneWizardCollection {...connectedProps} {...props} />}
  </Connect>
);

export default PageOneWizardCollectionContainer;
